import React from 'react'
import { Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import CheckboxDropdownList from './CheckboxDropdownList'
import GuidanceNote from '../../../components/GuidanceNote'

export default function Step2AssignClients({
  clients,
  clientOptions,
  title,
  search,
  page,
  fetchClients,
  handleSearchChange,
  updateSelectedClients,
  handleDeleteClient
}) {
  return (
    <>
      <div className="promo-form-section mt-10">
        <div className="title-promos-form">
          <b className="bold-step">
            Paso 2: Escoja los clientes que aplican para esta lista de precios
          </b>
        </div>
        <hr className="hr-promos-form-price" />
      </div>

      <div className="promo-form-section">
        {clients.some((client) => client.within_scope === false) && (
          <GuidanceNote
            title="Lista compartida"
            message="Los clientes fuera de tus asignaciones son de solo lectura. Puedes modificar únicamente tus clientes asignados."
            sx={{ mb: 2 }}
          />
        )}
        <div className="fake-validator-container">
          <CheckboxDropdownList
            users={clients}
            options={clientOptions}
            onSelectionChange={updateSelectedClients}
            onSearchChange={handleSearchChange}
            onLoadMore={() => fetchClients(search, page + 1)}
            disabled={!title}
          />
        </div>

        {clients.length > 0 && (
          <Table responsive className="mt-33">
            <thead className="table-header-gray">
              <tr>
                <th className="col-index">#</th>
                <th>ESTADO</th>
                <th>CÓDIGO</th>
                <th>NOMBRE</th>
                <th className="col-product">DIRECCIÓN</th>

                <th className="align-center-table-column">ELIMINAR</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client, index) => (
                <tr
                  key={client.uid}
                  aria-disabled={client.within_scope === false}
                  style={client.within_scope === false ? { opacity: 0.6 } : undefined}
                >
                  <td className="col-index">{index + 1}</td>
                  <td>{client.active ? 'Activo' : 'Inactivo'}</td>
                  <td>{client.uid}</td>
                  <td>{client.name || 'N/A'}</td>
                  <td>{client.address || 'N/A'}</td>

                  <td className="td-text-limited td-text-limited-center align-center-table-column">
                    <button
                      type="button"
                      disabled={client.within_scope === false}
                      title={
                        client.within_scope === false
                          ? 'Solo lectura: fuera de tus asignaciones'
                          : 'Quitar cliente'
                      }
                      className="delete-report-btn btn-delete-client"
                      onClick={() => handleDeleteClient(client.uid)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  )
}
